import { render } from "./BackgroundCircle.vue?vue&type=template&id=2bafab80&scoped=true"
import script from "./BackgroundCircle.vue?vue&type=script&lang=js"
export * from "./BackgroundCircle.vue?vue&type=script&lang=js"

import "./BackgroundCircle.vue?vue&type=style&index=0&id=2bafab80&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bafab80"]])

export default __exports__